/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popSysConfig.vue?vue&type=template&id=7b7c28ca&scoped=true"
import script from "./popSysConfig.vue?vue&type=script&lang=js"
export * from "./popSysConfig.vue?vue&type=script&lang=js"
import style0 from "./popSysConfig.vue?vue&type=style&index=0&id=7b7c28ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7c28ca",
  null
  
)

export default component.exports